function a(n, t) {
  const e = n.pane ?? t.pane;
  return e ? {
    ...n,
    pane: e
  } : n;
}
export {
  a as withPane
};
